<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="520" persistent>
    <v-card>
      <v-card-title class="mb-4">{{ $t('cookie.title') }}</v-card-title>

      <v-card-text class="pb-0">
        <p class="mb-6">{{ $t('cookie.text') }}</p>
        <a
          :href="$t('cookie.privacy-link-url')"
          target="_blank"
          rel="noopener noreferrer"
          class="cookie-privacy-link"
        >{{ $t('cookie.privacy-link') }}</a>

        <div class="d-flex align-center justify-space-between mt-6">
          <span>{{ $t('cookie.allow-stats') }}</span>
          <v-switch
            v-model="allowStats"
            inset
            hide-details
            class="mt-0 pt-0 flex-grow-0"
          />
        </div>
      </v-card-text>

      <v-card-actions class="justify-end pb-4 pr-4" style="margin-top: 24px;">
        <v-btn text color="primary" @click="save">{{ $t('cookie.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const CONSENT_KEY = 'ifpi_cookie_consent'
// 12 months in seconds
const CONSENT_MAX_AGE = 60 * 60 * 24 * 365
const SCRIPT_URL = 'https://t.contentsquare.net/uxa/590140b373a86.js'
const SCRIPT_ID = 'contentsquare-tracking'

const setCookie = function(value) {
  document.cookie = `${CONSENT_KEY}=${value}; max-age=${CONSENT_MAX_AGE}; path=/; SameSite=Lax`
}

export const loadConsentScript = function() {
  if (document.getElementById(SCRIPT_ID)) return
  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = SCRIPT_URL
  script.async = true
  document.head.appendChild(script)
}

export const unloadConsentScript = function() {
  const script = document.getElementById(SCRIPT_ID)
  if (script) script.remove()
}

export const getConsent = function() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + CONSENT_KEY + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

export const hasConsentChoice = function() {
  return getConsent() !== null
}

export default {
  name: 'CookieConsentDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      allowStats: getConsent() === 'accepted',
    }
  },

  watch: {
    value(open) {
      if (open) {
        this.allowStats = getConsent() === 'accepted'
      }
    },
  },

  methods: {
    save() {
      const wasAccepted = getConsent() === 'accepted'
      const nowAccepted = this.allowStats

      if (nowAccepted) {
        setCookie('accepted')
        loadConsentScript()
      } else {
        setCookie('rejected')
        if (wasAccepted) {
          unloadConsentScript()
          window.location.reload()
          return
        }
      }

      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
.cookie-privacy-link,
.cookie-privacy-link:visited {
  font-family: var(--font-family);
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-24);
  letter-spacing: var(--letter-spacing-15);
  color: var(--color-on-surface-variant);
  text-decoration: underline solid;
  text-decoration-skip-ink: auto;
}

.cookie-privacy-link--placeholder {
  color: inherit;
  cursor: default;
  text-decoration: none;
}
</style>
